import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <AboutSection />
        <FaqSection />
        <AppSection />
        <CarouselSection />
        <IndexSection />
        <ContactSection />
        <CommentsSection />
        <RankingSection />
        <TopicsSection />
        <MediaSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}